/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { map } from 'lodash';
import { useFormState } from 'react-final-form';
import { css, StyleSheet } from 'aphrodite';
import { Text, MaterialIcon, BrandColors, BrandColorKey } from '@blend/enterprise-components';

import { getPasswordRequirements } from 'id-utils/password';

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  horizontalSpacer: {
    marginRight: 8,
  },
  iconAdjustment: {
    position: 'relative',
    top: 1,
  },
  requirement: {
    alignItems: 'center',
    display: 'flex',
  },
  verticalSpacer: {
    ':not(:last-child)': {
      marginBottom: 4,
    },
  },
});

export namespace PasswordValidity {
  export interface Props {}
}

export const PasswordValidity: React.FC<PasswordValidity.Props> = ({}) => {
  const {
    values: { newPassword, confirmedPassword },
  } = useFormState<{ confirmedPassword: string; newPassword: string }>();
  const requirements = getPasswordRequirements(newPassword, confirmedPassword);
  const getRequirementStyling = (isMet: boolean): { colorName: BrandColorKey; icon: MaterialIcon.Props['type'] } => {
    if (!newPassword) return { colorName: 'CLOUD_50', icon: 'remove' };
    if (isMet) return { colorName: 'ACCENT_GREEN', icon: 'check' };
    return { colorName: 'ACCENT_RED', icon: 'clear' };
  };
  return (
    <div className={css(styles.container)}>
      {map(requirements, ({ description, isMet }) => {
        const { icon, colorName } = getRequirementStyling(isMet);

        return (
          <div className={css(styles.requirement, styles.verticalSpacer)} key={description}>
            <div className={css(styles.horizontalSpacer, styles.iconAdjustment)}>
              <MaterialIcon color={BrandColors[colorName]} size={24} type={icon} />
            </div>
            <Text colorName={colorName} fontSize="sm" key="description">
              {description}
            </Text>
          </div>
        );
      })}
    </div>
  );
};
